import "./sellscreendialogs.scss";
import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog } from "../../../Actions/Dialogs/DialogActions";
import { addCustomerToSale } from "../../../Actions/SellScreen/SellScreenCustomerActions";
import { default as CreateCustomerWizard } from "../../Customers/CustomerCreate";

const connector = connect();

interface Props extends ConnectedProps<typeof connector> {
    dispatch: ThunkDispatch<any, any, any>;
    onComplete?: (id: string) => void;
}

class CreateCustomer extends React.Component<Props> {
    protected handleCancel = (): void => {
        this.props.dispatch(hideDialog());
    };

    protected createCustomer = (id: string): void => {
        this.props.dispatch(hideDialog());

        if(this.props.onComplete) {
            this.props.onComplete(id);
        } else {
            this.props.dispatch(addCustomerToSale(id));
        }
    };

    public render(): React.ReactNode {
        return (
            <CreateCustomerWizard
                onComplete={this.createCustomer}
                onCancel={this.handleCancel}
            />
        );
    }
}

export default connector(CreateCustomer);
